import {alpha, darken, useTheme} from '@mui/material/styles';
import CookieConsent from 'react-cookie-consent';
import {themeUrl} from '../theme/themeConfig';

interface Props {
  text?: string;
}

export default function StyledCookieConsent({text}: Props) {
  const theme = useTheme();
  return (
    <CookieConsent
      buttonText="Alles klar"
      style={{
        zIndex: 1000000,
        backgroundColor: darken(theme.palette.primary.main, 0.45),
        color: theme.palette.primary.contrastText,
        fontFamily: theme.typography.fontFamily,
        fontSize: '0.9rem',
        lineHeight: 1.5,
        alignItems: 'center',
        padding: '4px 12px',
        boxShadow: `0 -12px 32px -16px ${alpha('#000', 0.5)}`,
      }}
      contentStyle={{flex: '1 0 300px', margin: '12px'}}
      buttonStyle={{
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        borderRadius: 999,
        fontWeight: 700,
        fontFamily: theme.typography.fontFamily,
        padding: '10px 22px',
        margin: '12px',
      }}
    >
      {text ??
        'Wir verwenden Cookies, um Ihnen ein optimales Nutzererlebnis zu bieten. ' +
        'Nutzen Sie unsere Website oder Dienste weiter, stimmen Sie der Verwendung zu.'}
      {' '}
      <a href={themeUrl('datenschutz.html')} style={{color: 'inherit', fontWeight: 700}}>Mehr&nbsp;Informationen</a>.
    </CookieConsent>
  );
}
